<!-- 附件预览 -->
<template>
  <div class="AttachEditor">
    <el-dialog
      id="file-previewer"
      key="file-previewer"
      ref="dialog__wrapper"
      append-to-body
      :title="$t('attach.preview')"
      :visible.sync="editorVisible"
      :close-on-click-modal="false"
      v-el-drag-dialog
      :modal="false"
      width="80%">
      <div id="monitorOffice" ref="monitorOffice" v-if="editorVisible"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closed">{{$t('buttons.close')}}</el-button>
      </span>
      <div
        class="line"
        v-elDragWidth:false="$refs.dialog__wrapper">
      </div>
    </el-dialog>
  </div>
</template>
<script>
import largeFile from '@/views/Report/ReportEditor/js/largeFile.js'
import { downloadFile } from '@/api/largeFile.js'
import { mapGetters } from 'vuex'
export default {
  name: 'AttachEditor',
  data() {
    return {
      editorVisible: false,
      docObj:undefined
    }
  },
  computed: {
    ...mapGetters(['token','solutionId','onlyOfficeSetting','userId','name'])
  },
  methods: {
    show(fileId,name,fileInfo,templateId,recordId){
      if(this.docObj){
        this.docObj.destroyEditor()
        this.docObj=undefined
      }
      this.editorVisible=true
      // var token="eyJhbGciOiJSUzI1NiIsImtpZCI6ImIxMjBjZTAxNGI0MmVlOTBlYTg1ZjI2ODQ1Mzc2NGZkIiwidHlwIjoiSldUIn0.eyJuYmYiOjE2MDI4MTY1MzIsImV4cCI6MTYwMjgyMDEzMiwiaXNzIjoiaHR0cDovL2xvY2FsaG9zdDo1MDAwIiwiYXVkIjpbImh0dHA6Ly9sb2NhbGhvc3Q6NTAwMC9yZXNvdXJjZXMiLCJ3b3JrZmluZSJdLCJjbGllbnRfaWQiOiJ3ZWIiLCJzdWIiOiIyIiwiYXV0aF90aW1lIjoxNjAyODE2NTMyLCJpZHAiOiJsb2NhbCIsInBfc2lkIjoiNDBCQTI1RTUtMjYxMy00OEVDLTkyMzYtNEQ1MDIwN0E3NDYzIiwicF9laWQiOiIxIiwic2NvcGUiOlsib3BlbmlkIiwibm9uLWRlc2lnbmVyIiwib2ZmbGluZV9hY2Nlc3MiXSwiYW1yIjpbInB3ZCJdfQ.pbpowpLJ-L63uwPcFin0iuLs5WtH_vSJdSKYX5nBk7s4-T0JubeEiqz3K2MkiK8nxjEgbV54_layOGMWMOHnN_RuNXvpnc5NMTrwi8xA0fHYC6pNzz6Pe8fILNKZPadZIl3GwOllRGb70bD8rJa7Ewp5teJHsUgvUzVyqtpYDZZRu_FTjb8wk2J9o-WzYkbDRh6OTVRK0GPw7VjbyDFsABtZgdCgd9C9_1bfRb8Lxw5yxb4fQx3AQzu_aZg-unk_p-Kv2eEIqzVTzpWjm7hD-u7i0U2e82hmnpZCJFFoR_B_ZzrrHjyLKf4LaRUucycvXQOTPa3rNX-Xe5yQ2fR3Hw"
      var config={
        document: {
          fileType: fileInfo.suffix,
          key: this.solutionId+'-'+fileId,
          // key: this.newGuid(),
          title: name,
          url: `${this.onlyOfficeSetting.storeAddress}/api/v1/documents/${fileId}?access_token=${this.token.replace('Bearer ','')}&templateId=${templateId}&recordId=${recordId}`// this.token
        },
        documentType: fileInfo.type,//TODO:text，spreadsheet，presentation
        editorConfig: {
          region: "zh-CN",
          lang: "zh-CN",
          customization:{
            autosave:false,
            forcesave:true,
            chat:false,
            comments:false,
            compactHeader:true,
            customer:{
              address:"江苏省无锡市惠山区惠山大道108号A635",
              info:"Workfine文档在线预览",
              // logo:"http://host.docker.internal:13210/images/image0.png",
              mail:"support@bossietech.com",
              name:"无锡柏思科技有限公司",
              www:"http://www.bossietech.com"
            },
            feedback:{
              url:"http://www2.bossietech.cn/bbs/",
              visiable:true
            },
            help:false,
            // logo:{
            //   image:"http://host.docker.internal:13210/images/image0.png",
            //   imageEmbedded :"http://host.docker.internal:13210/images/image0.png",
            //   url:"http://www.bossietech.com"
            // },
            spellcheck:false,

          },
          mode: "view",// TODO:控制是否编辑模式:edit/view
          // callbackUrl: `http://host.docker.internal:13210/api/v1/documents/${fileId}?access_token=`+this.token.replace('Bearer ',''),
          user:{
            id:this.userId,
            name:this.name
          },
        },
        permissions:{
          changeHistory: false,
          comment: false,
          download: true,
          fillForms: true,
          modifyContentControl: true,
          modifyFilter: false,
          print: true,
          review: true
        }
      }
      this.$nextTick(()=>{
        this.docObj=new DocsAPI.DocEditor("monitorOffice",config );
        console.log(config,this.docObj)
      })
    },
    onDocumentReady(obj){
      console.log('文件打开完毕！')
    },
    closed() {
      if(this.docObj){
        this.docObj.destroyEditor()
        this.docObj=undefined
      }
      this.editorVisible = false
    },
    newGuid(){
      var guid = "";
      for (var i = 1; i <= 32; i++){
        var n = Math.floor(Math.random()*16.0).toString(16);
        guid +=   n;
        if((i==8)||(i==12)||(i==16)||(i==20))
        guid += "-";
      }
      return guid;    
    }
  }
}
</script>
<style lang="scss">
  a.el-link{
   display: block !important;
  }
  .viewer-container{
    z-index: 9999 !important;
  }
  .AttachEditor .el-dialog__body{
    margin-top: -10px;
  }
  /* .download-button{
    margin-top: 0px;
    margin-bottom: 10px;
  } */
</style>